import { useRouter } from "next/router"
import { default as NextLink } from "next/link"
import useMenuItems from "@/lib/helpers/menu"
import { useCopy, useMeta } from "@/lib/contexts/appContext"
import Link from "@/components/common/menu/link"
import styles from "./top.module.css"

export default function MenuTop({ hasMounted, isNarrow }) {
  const { hideSwitcher } = useMeta()
  const { general } = useCopy()
  const { locale } = useRouter()
  const location = "top-bramiljoval"
  const items = useMenuItems(location)
  if (!items) {
    return null
  }

  if (hasMounted && isNarrow) {
    return null
  }

  const oppositeLocale = locale === "sv" ? "en" : "sv"

  return (
    <ul className={styles.menu} role="menu" data-location={location + "-menu"}>
      {items.map((item) => (
        <li role="menuitem" key={item.url}>
          <Link item={item} location={location} />
        </li>
      ))}
      {!hideSwitcher && (
        <li role="menuitem">
          <NextLink href="/" locale={oppositeLocale} prefetch={false}>
            {general?.langSwitcher}
          </NextLink>
        </li>
      )}
    </ul>
  )
}
